//console.log(tgblResourcesFrontend)

import algoliasearch from 'algoliasearch/lite';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';

const resourcesAlgoliaSearch = ($) => {

  if (!window.Tangible) return
  const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig
  const tangibleSelect = window.Tangible.Select

  // Global object
  window.AlgoliaSearch = {}

  $(document).ready(function () {
    window.AlgoliaSearch.constructor()
  })

  window.AlgoliaSearch = {

    // initialize the code
    constructor: function () {
      this.algoliaSearch()
      if(tgblResourcesFrontend.algolia_autocomplete == 'yes') {
        this.algoliaAutocompleteSearch()
      }
    },

    algoliaAutocompleteSearch: function() {

      const searchClient = algoliasearch(
        window.atob(tgblResourcesFrontend.EAID),
        window.atob(tgblResourcesFrontend.EAK)
      );

      //console.log('algolia_autocomplete : ',tgblResourcesFrontend.algolia_autocomplete, 'EAID: ',window.atob(tgblResourcesFrontend.EAID), 'EAK :', window.atob(tgblResourcesFrontend.EAK) )
      // EAID:  B379SNDHUH EAK : 4c4a747c32757c8f1e0bff5088cedb53

      const autocomplete_container =$('#tgbl_algolia_autocomplete')

      if(autocomplete_container.length) {
        autocomplete({
          container: '#tgbl_algolia_autocomplete',
          placeholder: tgblResourcesFrontend.localized.searchresources,
          //debug:true,
          getSources({query}) {
            return window.AlgoliaSearch.algoliaGetSources(query, searchClient)
          }, // end getSources
        }) // end autocomplete
      }
    },

    algoliaGetSources: function(query,searchClient) {

      const arr = []

      $.each(tgblResourcesFrontend.indexes_suggestions_arr, function(key,valueObj){
        //console.log(key + "/" + valueObj );
        /*
        wp_posts_cox-resource/10
        wp_posts_cox-model-classroom/10
         */
        const attributesToSnippet = (key == 'wp_posts_cox-resource' )?['post_title:10','resource_short_desc:25']:['post_title:10', 'content:25']
        const attributesToRetrieve = (key == 'wp_posts_cox-resource' )?['post_title','resource_short_desc']:['post_title', 'content']
        const snippet_attribute = (key == 'wp_posts_cox-resource' )?'resource_short_desc':'content'

        arr.push(
          {
            sourceId: key,
            getItems() {
              return getAlgoliaResults({
                searchClient,
                queries: [
                  {
                    indexName: key,
                    query,
                    params: {
                      hitsPerPage: valueObj,
                      attributesToRetrieve: attributesToRetrieve,
                      attributesToSnippet: attributesToSnippet,
                      snippetEllipsisText: '…',
                    },
                  },
                ],
              });
            },

            getItemInputValue({ item }) {
              //console.log(item)
              return item.post_title
            },

            templates: {
              item({ item, components, html }) {
                return html`<div class="aa-ItemWrapper">
                <div class="aa-ItemContent">

                <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentTitle">
                    ${components.Highlight({
                  hit: item,
                  attribute: 'post_title',
                })}
                  </div>
                  <div class="aa-ItemContentDescription">
                    ${components.Snippet({
                  hit: item,
                  //attribute: 'content',
                  attribute: snippet_attribute,
                })}
                  </div>
                </div>
                <div class="aa-ItemActions">
                  <button
                    class="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                    type="button"
                    title="Select"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="currentColor"
                    >
                      <path
                        d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z"
                      />
                    </svg>
                    </button>
                  </div>
                </div>
              </div>`;
              },
            },// end templates
          },
        ) // end push arr
      }) // end each

      return arr
    },

    algoliaSearch: function() {

      const search_box_wrap =  $('.tgbl-resource-search-box-wrap')

      const apply_filters = $('.tgbl-resource-filters-wrap .action.apply-filters')

      const search_button_selector = tgblResourcesFrontend.algolia_autocomplete == 'yes' ? '.aa-SubmitButton' : '.search-button'
      const clear_search_button_selector = tgblResourcesFrontend.algolia_autocomplete == 'yes' ? '.aa-ClearButton' : '.clear-search-button'
      const search_input_selector = tgblResourcesFrontend.algolia_autocomplete == 'yes' ? '.aa-Input' : '.search-input'

      search_box_wrap.on('click', search_button_selector, function(e){
        //e.preventDefault()
        apply_filters.trigger('click')
      })

      search_box_wrap.on('click', clear_search_button_selector, function(e){
        //e.preventDefault()
        search_box_wrap.find(search_input_selector).val('')
        apply_filters.trigger('click')
      })

      $('body').on('keypress',search_input_selector, function(e){
        var keycode = (e.keyCode ? e.keyCode : e.which);
        if(keycode == '13'){
          apply_filters.trigger('click')
        }
        e.stopPropagation();
      })
    },
  }
}

export { resourcesAlgoliaSearch }

